// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__agRpE","rsscontainer":"styles_rsscontainer__16kRL","rssfeedtitle":"styles_rssfeedtitle__AvCMe"};